import { useCallback } from 'react';
import { ContentNode } from '@amzn/awscat-pattern-library-service-model';

import { sectionIdForNode } from '../v2-common/ContentNodeExtensions';
import { useNavigateToSection } from '../v2-hooks/useUrlHash';

/** Presentation state for the "Next page" button on the Contents tab. */
export interface NextPageButtonViewModel {
  /** True when there is no next page in DFS order from the current page. */
  readonly isDisabled: boolean;
  /** Update the URL hash to the next page. No-op when disabled. */
  readonly navigateToNextPage: () => void;
}

/**
 * Drives the "Next page" button and navigates the URL hash on click.
 * The parent derives nextPage from the same content snapshot as the current page.
 */
export function useNextPageButtonViewModel(
  nextPage: ContentNode | undefined,
): NextPageButtonViewModel {
  const navigateToSection = useNavigateToSection();

  const navigateToNextPage = useCallback(() => {
    if (!nextPage) return;
    navigateToSection(sectionIdForNode(nextPage));
  }, [nextPage, navigateToSection]);

  return {
    isDisabled: !nextPage,
    navigateToNextPage,
  };
}
